<!-- p-overlayPanel (Popup Menu) -->
<p-overlayPanel #menuOverlay [style]="{ width: '221px', height: '223px' }" [dismissable]="true">
    <div class="menu-container absolute pl-5">
        <div *ngFor="let item of menuItems" 
             class="text-left mb-3 cursor-pointer text-[18px] text-[#232F41]" 
             (click)="onNavigate(item)">
            {{ item.title }}
        </div>
    </div>
</p-overlayPanel>
